// 时间格式化函数，返回 00:00 形式
export const formatTimeAsMinutesAndSeconds = (seconds: number) => {
  if (!seconds) return "";
  const mins = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const secs = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");
  return `${mins}:${secs}`;
};

export const getThumb = (file: File) => {
  console.log("file.type", file);

  if (file.type.startsWith("image")) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.readAsDataURL(file);
    });
  } else {
    // 视频ios下拿不到封面，暂时不处理
    return Promise.resolve("");
  }
  // else {
  //   return new Promise((resolve, reject) => {
  //     const video = document.createElement("video");
  //     video.preload = "metadata";

  //     video.onloadeddata = () => {
  //       video.currentTime = 0.5;
  //     };

  //     // video.oncanplay = () => {
  //     //   video.currentTime = 0.5; // 确保 seek 操作生效
  //     // };

  //     video.onseeked = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = video.videoWidth;
  //       canvas.height = video.videoHeight;

  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  //       const coverUrl = canvas.toDataURL("image/jpeg");
  //       URL.revokeObjectURL(video.src);
  //       resolve(coverUrl);
  //     };

  //     video.onerror = () => {
  //       reject(new Error("视频加载失败"));
  //     };
  //     video.src = URL.createObjectURL(file);
  //     video.load();
  //   });
  // }
};

export const getVideoDuration = (file: File) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");

    // iOS 必须的设置
    video.muted = true; // 必须静音
    video.playsInline = true; // 必须设置
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.preload = "metadata";

    // 超时处理
    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error("获取视频时长超时"));
    }, 5000); // 5秒超时

    const cleanup = () => {
      clearTimeout(timeout);
      video.src = "";
      video.remove();
    };

    // 替代事件监听方案
    const checkReady = () => {
      if (video.readyState >= 1) {
        // HAVE_METADATA
        clearTimeout(timeout);
        const duration = video.duration;
        cleanup();
        resolve(duration);
      } else {
        requestAnimationFrame(checkReady);
      }
    };

    video.onerror = () => {
      cleanup();
      reject(new Error("视频加载失败"));
    };

    // 开始处理
    video.src = URL.createObjectURL(file);

    // 使用轮询替代事件监听
    checkReady();
  });
};
